import { render, staticRenderFns } from "./AgenticAICka.vue?vue&type=template&id=dc3009d6&scoped=true"
import script from "./AgenticAICka.vue?vue&type=script&lang=js"
export * from "./AgenticAICka.vue?vue&type=script&lang=js"
import style0 from "./AgenticAICka.vue?vue&type=style&index=0&id=dc3009d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc3009d6",
  null
  
)

export default component.exports